module.exports = __webpack_public_path__ + "img/grt.4e96553e.svg";